// @flow
export const MUSICAL_EQUIPMENT_SUBMIT = "booking/MUSICAL_EQUIPMENT_SUBMIT"
export const MUSICAL_EQUIPMENT_SUBMIT_FAILURE = "booking/MUSICAL_EQUIPMENT_SUBMIT_FAILURE"

export default MUSICAL_EQUIPMENT_SUBMIT
